<template>
  <li v-if="isShowableEvent">
    <div class="row">
      <div class="col-lg-9">
        {{ who }}
        <template v-if="isCreationEvent">
          created a new {{ what }}
        </template>
        <template v-else-if="isDeletionEvent">
          deleted a {{ what }}
        </template>
        <template v-else-if="isLocationEvent">
          changed the {{ field }} details
        </template>
        <template v-else-if="isLoadRequestSentEvent">
          sent a load request to a carrier
        </template>
        <template v-else-if="isLoadRequestDeclinedEvent">
          declined a load request
        </template>
        <template v-else>
          changed the {{ field }}
          on {{ definiteOrIndefinite }} {{ what }}
          <template v-if="from">
            from {{ from }}
          </template>
          to {{ to }}
        </template>
      </div>
      <div class="col-lg-3 text-right text-muted">
        <em>{{ item.date }}</em>
      </div>
    </div>
  </li>
</template>

<script>
  export default {
    props: ['item'],

    computed: {
      isCreationEvent () {
        return this.field === 'created_at' && this.from === null
      },

      isDeletionEvent () {
        return this.field === 'deleted_at' && this.to === 'deleted'
      },

      isLocationEvent () {
        return this.field === 'location from' || this.field === 'location to'
      },

      isLoadRequestSentEvent () {
        return this.field === 'request_sent' && this.to === 'yes'
      },

      isLoadRequestDeclinedEvent () {
        return this.field === 'request_declined' && this.to === 'yes'
      },

      isShowableEvent () {
        // If a carrier declines a request we want to hide the "request_sent" changed.
        if (this.field === 'request_sent' && this.from === 'yes' && this.to === 'no') {
          return false
        }

        return true
      },

      definiteOrIndefinite () {
        switch (this.what) {
          case 'load':
            return 'a'
          case 'job':
            return 'the'
        }
      },

      who () {
        return this.item.responsible || 'Someone'
      },

      what () {
        return this.item.what
      },

      field () {
        return this.item.field
      },

      from () {
        return this.item.from
      },

      to () {
        return this.item.to || 'nothing'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HistoryItem.vue?cec6e612